import { ASSETS_NAMES } from '@/shared/utils/constants';
import { Crypto } from '@/types/crypto';
import { IonRow } from '@ionic/react';
import { t } from 'i18next';
import { QRCodeSVG } from 'qrcode.react';
import { useState } from 'react';
import Icon from '../../Icon/Icon';
import TermsConditions from '../../TermsConditions/TermsConditions';
import styles from '../DepositWithdraw.module.css';

type Props = {
  assetId: string;
  cryptoData?: Crypto;
  cryptoLoading: boolean;
  handleCopy: () => void;
};

const CryptoDeposit: React.FC<Props> = ({ assetId, cryptoData, cryptoLoading, handleCopy }) => {
  const [termsAccepted, setTermsAccepted] = useState(false);

  const handleTerms = () => {
    setTermsAccepted(true);
  };

  return (
    <>
      {termsAccepted ? (
        <>
          <IonRow class="ion-justify-content-center">
            <span>
              {t('wallet.deposit.asset.cta', {
                assetName: ASSETS_NAMES[assetId || 'btc']
              })}
            </span>
          </IonRow>

          <div className={styles.cryptoAddressContainer}>
            <span className={styles.spacing}>
              <span>
                {cryptoLoading ? (
                  '...'
                ) : (
                  <span className={styles.cryptoAddress}>
                    {cryptoData && cryptoData.address ? cryptoData.address : 'N/A'}
                  </span>
                )}
                {cryptoData && (
                  <span className={styles.iconCopy} onClick={handleCopy}>
                    <Icon src={`assets/icons/copy-outline.svg`} size="medium" color="primary" className={styles.icon} />
                  </span>
                )}
              </span>
            </span>
          </div>

          {assetId === 'xrp' && (
            <div>
              {' '}
              <IonRow class="ion-justify-content-center">
                <span>{`${t('wallet.withdrawals.crypto.destination_tag')}:`}</span>
              </IonRow>
              <div className={styles.destinationIDContainer}>
                <span className={styles.spacing}>
                  <span>
                    {cryptoLoading ? (
                      '...'
                    ) : (
                      <span className={styles.destinationTag}>
                        {cryptoData?.tag && cryptoData.tag ? cryptoData.tag : 'N/A'}
                      </span>
                    )}
                  </span>
                </span>
              </div>
            </div>
          )}

          <IonRow class="ion-justify-content-center ion-margin-bottom">
            {cryptoData && (
              <div className={styles.qrcode}>
                <QRCodeSVG value={cryptoData?.address} />
              </div>
            )}
          </IonRow>

          <div className={styles.warning}>
            <Icon src={`assets/icons/warning-outline.svg`} size="large" color="warning" />
            <div className={styles.warningColumn}>
              <small className={styles.warningTitle}>
                {t('wallet.deposit.asset.warning.title', {
                  assetName: ASSETS_NAMES[assetId || ''],
                  assetSymbol: assetId.toUpperCase()
                })}
              </small>

              <small className={styles.warningText}>{t('wallet.deposit.asset.warning')}</small>
            </div>
          </div>
        </>
      ) : (
        <TermsConditions assetId={assetId} termsHandler={handleTerms} />
      )}
    </>
  );
};

export default CryptoDeposit;
